import { Text } from "../Text";

export interface BuildVersionProps {
  env: string | undefined;
  version: string | undefined;
  className?: string;
}

export function BuildVersion({ env, version, className }: BuildVersionProps) {
  if (!version) return null;
  return (
    <Text size="xs" className={className} style={{ color: "var(--color-text-secondary)" }}>
      {env ?? "dev"} · {version.slice(0, 7)}
    </Text>
  );
}
